import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IdexService} from '../../idex.service';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Toast} from '../../shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {DeleteAttachFileComponent} from '../delete-attach-file/delete-attach-file.component';
import {DateAdapter} from '@angular/material/core';
import { TaskAttribute } from '../create-task/create-task.type';

declare var $: any;

@Component({
   selector: 'app-attach-file',
   templateUrl: './attach-file.component.html',
   styleUrls: ['./attach-file.component.css']
})
export class AttachFileComponent implements OnInit {
   private chunkSize = 1048576;
   public documents: any;
   public dueDateObject;
   public backupIdFolderExport;
   public backupPathExport;
   public docNew: string[] = [];
   public files = [];
   object_file: any;
   count: any;
   checkDelete = false;
   @Input() taskAttribute: TaskAttribute;
   @Input() documentslist: any;
   @Input() typeName: string;
   @Input() signer: any;
   @Output() handle = new EventEmitter<any>();
   @Output() listClick = new EventEmitter<any>();
   @Output() updatefile = new EventEmitter<any>();
   @Input() link = '';
   @Input() idFolderExport: string;
   public listDoc = [];
   public doclists2 = [];
   public doclist = {
      docId: '',
      docName: '',
      totalPages: '',
      signItems: [],
      isAttachFile: ''
   };

   folders = [
      {
         name: 'Photos',
         updated: new Date('1/1/16'),
      },
      {
         name: 'Recipes',
         updated: new Date('1/17/16'),
      },
      {
         name: 'Work',
         updated: new Date('1/28/16'),
      }
   ];

   constructor(public service: IdexService, public dialog: MatDialog,
               public toast: Toast,
               private translate: TranslateService, private router: Router,
               private dateAdapter: DateAdapter<any>) {
                  this.service.loadFileMaxUpload();
   }

   ngOnInit() {
      this.setListDocSelect();
      this.docNew = [];
      this.doclists2 = this.taskAttribute.docList;
      this.dueDateObject = new Date(this.taskAttribute.dueDate);
      if (this.taskAttribute.templateId) {
         this.service.getTemplate(this.taskAttribute.templateId)
            .subscribe((data) => {
                  this.taskAttribute.apvLevel = data.apvLevel;
                  this.setSignItems(data);
               },
               (err) => {
                  console.error(err);
               });
      }
      this.translate.get('langCurrent').subscribe((msg) => {
         if (msg === 'th') {
            this.dateAdapter.setLocale('th');
         } else {
            this.dateAdapter.setLocale('en');
         }
      });
      this.backupIdFolderExport = this.idFolderExport;
      this.backupPathExport = this.link;
   }

   setListDocSelect() {
      this.listDoc = [];
      this.documents = this.taskAttribute.docList; // .filter(docs => docs.isAttachFile === true);
      for (let i = 0; i < this.documents.length; i++) {
         if (i === 0) {
            this.listDoc.push('active');
         } else {
            this.listDoc.push('');
         }
      }
   }

   private init(loopFile: any): Observable<any> {
      return this.service.get('/init/upload/' + loopFile);
   }

   setSignItems(data) {
      this.documents = data;
   }

   onSelectFiles(input: any) {
      if (input.files.length === 0) {
         return;
      }
      const files = input.files;
      this.uploadDoc(files);
   }

   validateFile(myFile: any) {
      const $input = $('input[type=file]');
      if (this.typeName === 'template') {
         if (myFile.length > 1) {
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.handleToastError('uploadDoc.errorSelectFile');
            return false;
         } else if (this.taskAttribute.docList.length > 0) {
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.handleToastError('uploadDoc.errorUpload');
            return false;
         }
      }

      for (let i = 0; i < myFile.length; i++) {
         if (myFile[i] != null) {
            const ext = myFile[i].type;
            if (ext !== '' && this.validateExtension(ext) === true) {
               if (myFile[i].size > this.service.fileMaxUpload) { // 2097152
                  $input.val('');
                  $input.attr('title', window.URL ? ' ' : '');
                  this.translate.get('uploadDoc.errorFileSize', {size: this.service.getFileMaxUploadMB()}).subscribe(s => this.toast.error(s));
                  return false;
               }
            } else {
               $input.val('');
               $input.attr('title', window.URL ? ' ' : '');
               this.handleToastError('uploadDoc.errorPdf');
               return false;
            }
         }
      }
      return true;
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   validateExtension(v) {
      const allowedExtensions = new Array(
         'image/bmp', 'application/msword', 'application/pdf',
         'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
         'image/jpeg', 'image/png', 'application/vnd.ms-powerpoint',
         'application/vnd.openxmlformats-officedocument.presentationml.presentation',
         'text/plain', 'image/tiff', 'application/vnd.ms-excel',
         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );

      for (let ct = 0; ct < allowedExtensions.length; ct++) {
         const fileSelected = v.toLowerCase().lastIndexOf(allowedExtensions[ct]);
         if (fileSelected !== -1) {
            return true;
         }
      }
      return false;
   }

   /** อัปโหลดไม่สำเร็จ: ปิด loading (เปิดไว้ตั้งแต่เริ่มอัปโหลด ไม่อย่างนั้นจะค้าง) และล้าง input */
   private uploadFailed(file: any, error: any) {
      file.error = error?.message || error;
      const $input = $('input[type=file]');
      $input.val('');
      $input.attr('title', window.URL ? ' ' : '');
      this.object_file = null;
      this.handle.emit(false);
   }

   uploadDoc(files: any) {
      if (this.validateFile(files)) {
         // แสดง loading ตั้งแต่เริ่มส่งไฟล์ (ไฟล์ใหญ่ใช้เวลาส่งหลายสิบวินาที เดิมขึ้น loading ตอนส่งครบแล้วเท่านั้น)
         // ปิดเมื่อหน้าลงนามโหลดเอกสารใหม่เสร็จ (updatefile) หรือเมื่ออัปโหลดไม่สำเร็จ
         this.handle.emit(true);
         this.count = 0;
         if (this.object_file === undefined || this.object_file === null) {
            this.object_file = [];
         }
         for (let loopFile = 0; loopFile < files.length; loopFile++) {
            files[loopFile].fullPath = files[loopFile].webkitRelativePath;
            this.object_file.push(files[loopFile]);
            const file: any = files[loopFile];
            this.init(loopFile).subscribe(result => {
               const key = result.key;
               const fileNo = result.fileNo;
               let offset = 0;
               const xhr = new XMLHttpRequest();
               const send = () => {
                  const end = Math.min(offset + this.chunkSize, file.size);
                  xhr.open('PUT', this.service.url + '/upload/' + key, true);

                  xhr.setRequestHeader('x-auth-token', this.service.user.token);
                  xhr.setRequestHeader('Content-Range', 'bytes ' + offset + '-' + (end - 1) + '/' + file.size);
                  const blob = file.slice.call(file, offset, end);
                  xhr.send(blob);
               };
               xhr.onload = () => {
                  if (xhr.status === 308) {
                     if (file.canceled) {
                        this.service.post('/cancel/upload/' + key, null).subscribe(() => {
                              // This is intentional.
                           },
                           (err) => {
                              console.error(err);
                           });
                        return;
                     }
                     offset += this.chunkSize;
                     send();
                  } else if (xhr.status === 201) {
                     this.finish(key, '', file, '', fileNo, loopFile, files.length);
                  } else {
                     this.uploadFailed(file, xhr.statusText || ('HTTP ' + xhr.status));
                  }
               };
               xhr.onerror = () => this.uploadFailed(file, 'Network error');
               send();
            }, error => {
               this.uploadFailed(file, error);
            });

            if (this.typeName === 'template') {
               break;
            }
         }
      }
   }

   finish(key: string, path: string, file: any, tin: string, id?: string, loopFile?: any, size?: any) {
      const body = {
         name: file.fullPath || file.name,
         destination: path,
         mimeType: file.type,
         tin: tin,
         id: id
      };
      if (this.count === 0) {
            this.handle.emit(true);
      }
      this.service.uploadDocumentTemp('task', body, loopFile, key).subscribe((response) => {
         const object_file = this.object_file[response.fileIndex];
         const docId = response.docId;
         const docName = response.docName;
         const objectDoclist = {
            docId: '',
            docName: '',
            totalPages: '',
            version: '1.0',
            isAttachFile: true,
            signItems: [],
            uploadBy: ''
         };
         objectDoclist.docId = docId;
         objectDoclist.docName = docName;
         objectDoclist.uploadBy = this.service.user.email;

         this.files.push({object_file, docId, docName});
         this.docNew.push(docId);
         this.documentslist.push(objectDoclist);
         this.documents = this.taskAttribute.docList;
         this.object_file.splice(0, 1);
         if (this.object_file.length === 0) {
            const $input = $('input[type=file]');
            $input.val('');
            $input.attr('title', window.URL ? ' ' : '');
            this.object_file = null;
         }
         this.service.saveTaskAttachFile(this.taskAttribute, docId)
            .subscribe((suc) => { // call service saveTask
                  this.count = this.count + 1;
                  if (this.count === size) {
                     this.translate.get('alert.insert-attach-file').subscribe(s => {this.toast.success(s); });
                     this.updatefile.emit({action: 'insert', order: 0, docList: this.documentslist});
                     this.listDoc.length = this.taskAttribute.docList.length;
                  }
               },
               (err) => {
                  console.error(err);
                  this.handle.emit(false);
               });
      }, error => {
         this.uploadFailed(file, error);
      });
   }

   public onListClick(object) {
      this.isSelected(object.index);
      this.listClick.emit(object);
   }

   isSelected(index) {
      for (let i = 0; i < this.listDoc.length; i++) {
         if (i === index) {
            this.listDoc[i] = 'active';
         } else {
            this.listDoc[i] = '';
         }
      }
   }

   deleteFile(object , event: Event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const dialogRef = this.dialog.open(DeleteAttachFileComponent, {
         disableClose: true,
         height: '110px',
         data: {
            service: this.service,
            taskId: object.taskId,
            toast: this.toast,
            docId: object.docId,
            router: this.router,
         }
      });

      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.translate.get('alert.delete-attach-file').subscribe(s => {this.toast.success(s); });
            this.taskAttribute.docList.splice(object.index, 1);
            this.files.splice(object.index, 1);
            if (object.index === this.taskAttribute.docList.length) {
               this.isSelected(object.index - 1);
            } else {
               this.isSelected(object.index );
            }
            this.updatefile.emit({action: 'delete', order: object.index, docList: this.taskAttribute.docList});
         }
      });
   }
}
